import { cva } from "class-variance-authority";
/** Outer wrapper for recover email / password personal-info screens. */
export const recoverFormStyles = cva([
    "auth-welcome",
    "w-full",
    "flex",
    "flex-col",
    "gap-0",
    "pt-8",
    "pb-8",
    "px-4",
    "md:gap-8",
    "md:items-center",
    "md:pt-0",
    "md:pb-8",
    "md:px-0",
    "lg:pt-0",
    "lg:pb-16",
], {
    variants: {},
    defaultVariants: {},
});
/** Card wrapper for form fields (tablet+). */
export const recoverFormContentStyles = cva([
    "w-full",
    "md:auth-card",
    "md:bg-white",
    "md:rounded-2xl",
    "md:shadow-md",
    "md:py-8",
    "md:px-6",
    "md:max-w-[396px]",
    "lg:px-8",
    "lg:max-w-[476px]",
], {
    variants: {},
    defaultVariants: {},
});
/** Action buttons below fields. */
export const recoverFormButtonGroupStyles = cva([
    "flex",
    "flex-col",
    "gap-4",
    "!mt-8",
    "lg:flex-row-reverse",
    "lg:gap-4",
], {
    variants: {},
    defaultVariants: {},
});
/** Error banner spacing aligned with card width. */
export const recoverFormErrorStyles = cva([
    "mt-6",
    "mb-8",
    "w-full",
    "md:mt-4",
    "md:max-w-[396px]",
    "lg:max-w-[476px]",
], {
    variants: {},
    defaultVariants: {},
});
//# sourceMappingURL=recover-form-layout.styles.js.map